import Enum from "../../../../enums/Enum";

const IntakeFormAnyMedicationSupplementEnum = new Enum({
    No: {name: "No", nameInArabic: "لا"},
    Current: {name: "Current", nameInArabic: "نعم حالياً"},
    Previous: {name: "Previous", nameInArabic: "نعم في السابق"},
    Long_term: {name: "Long-term", nameInArabic: "نعم منذ مدة طويلة"},
});

export default IntakeFormAnyMedicationSupplementEnum;